// @core/api/endpoints/task/get_container_config_by_entity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ContainerConfigResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Get container config by entity
 * Looks up task configuration for a container entity (project, team, pipeline). Returns empty config if none exists.
 */
export async function GetContainerConfigByEntity(
  entity_type: string,
  entity_id: string,
  options?: RequestOptions
): Promise<ContainerConfigResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/entities/:entity_type/:entity_id/container-config`;
  requestPath = requestPath.replace(':entity_type', encodeURIComponent(entity_type));
  requestPath = requestPath.replace(':entity_id', encodeURIComponent(entity_id));
  const requestOptions = options;
  return client.get<ContainerConfigResponse>(requestPath, { ...requestOptions });
}
